import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReportAPI } from "../api/report";
import Loader from "../componets/Loader";
import ReportLogo from "../assets/SVGs/Report/ReportLogo";
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PrintReport from "../assets/SVGs/Report/PrintReport";
import dayjs from "dayjs";

const ACTIVITY_TYPE_COLORS = {
  "Referral given": { bg: "#E0E7FF", color: "#3730A3" },
  "Referral received": { bg: "#DBEAFE", color: "#1E40AF" },
  "Closed business": { bg: "#DCFCE7", color: "#166534" },
  Visitor: { bg: "#FEF3C7", color: "#92400E" },
  "Weekly meet": { bg: "#F1F5F9", color: "#334155" },
  "Meet-up": { bg: "#FCE7F3", color: "#9D174F" },
};

const MemberExtendedReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  const fetch = async () => {
    setIsLoading(true);
    try {
      const res = await ReportAPI.getMemberActivityFeed(
        localStorage?.getItem("memberId"),
      );
      setData(res?.data);
    } catch (error) {
      const status = error.response?.status;
      if (status === 401) {
        navigate("/login");
      } else {
        console.error("Error fetching member extended report:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    window.print();
  };

  const records = data?.records || [];

  return isLoading ? (
    <Loader height="100vh" />
  ) : (
    <div className="report-section flex flex-col gap-16">
      <header className="report-header flex align-center justify-between flex-col gap-16">
        <ReportLogo width={122} height={50} />

        <div className="header-section flex align-center justify-between flex-col">
          <h1 className="header-title">{`${data?.full_name} Extended Report`}</h1>

          <IconButton
            sx={{
              border: "1px solid #AEBBCB",
              "@media print": {
                display: "none", // Hides the button during print
              },
            }}
            onClick={handlePrint}
            className="no-print"
          >
            <PrintReport className="no-print" />
          </IconButton>
        </div>
      </header>

      <Stack
        sx={{
          width: "100%",
          "& .MuiTable-root": {
            borderRadius: "8px",
          },
        }}
        className="customTable report-table"
      >
        <TableContainer component={Paper} className="customTable">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "160px" }}>Date</TableCell>
                <TableCell sx={{ width: "200px" }}>Activity Type</TableCell>
                <TableCell>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {records.length > 0 ? (
                records.map((record, index) => {
                  const chipStyle = ACTIVITY_TYPE_COLORS[
                    record.activity_type
                  ] || { bg: "#F1F5F9", color: "#334155" };
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        {dayjs(record.event_date).format("MM/DD/YYYY")}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={record.activity_type}
                          size="small"
                          sx={{
                            backgroundColor: chipStyle.bg,
                            color: chipStyle.color,
                            fontWeight: 500,
                          }}
                        />
                      </TableCell>
                      <TableCell>{record.description}</TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <Box display="flex" justifyContent="center">
                      No Data Found
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </div>
  );
};

export default MemberExtendedReport;
